import { render, staticRenderFns } from "./CustomWarningComponent.vue?vue&type=template&id=804e4bb0&scoped=true&"
import script from "./CustomWarningComponent.vue?vue&type=script&lang=ts&"
export * from "./CustomWarningComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CustomWarningComponent.vue?vue&type=style&index=0&id=804e4bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804e4bb0",
  null
  
)

export default component.exports